<div class="city-bg" style="background-image: url(/images/city.svg);"></div>
<div class="login-container drop-shadow bottom">
  <h1 class="login--header">Reset your password</h1>
  <form [formGroup]="form" (submit)="submit(form)" class="std-form" autocomplete="off" novalidate>
    <div [formGroup]="passwords" class="form-group" [ngClass]="{'danger':(passwords.controls['password'].invalid && submitted) || (passwords.controls['password'].hasError('passwordPolicy') && !passwords.controls['password'].hasError('required'))}">
      <label for="password">Password</label>
      <show-password [inputFields]="[field1, field2]">
        <input id="password" #field1 [ngClass]="{'check':passwords.controls['password'].valid}" class="form-control" type="password" [formControl]="passwords.controls['password']">
      </show-password>
      <span *ngIf="passwords.controls['password'].hasError('passwordPolicy'); else elseBlock" class="validation-msg">
        <span [hidden]="!passwords.controls['password'].hasError('passwordPolicy') || passwords.controls['password'].hasError('required')">WEAK</span>
      </span>
      <ng-template #elseBlock>
        <span class="validation-msg">STRONG</span>
      </ng-template>
      <div *ngIf="passwords.controls['password'].hasError('passwordPolicy') && submitted" class="validation-msg">
        <p>Your password isn't sufficiently complex. Please make sure it meets the following rules:</p>
        <ul>
          <li>Contains at least one number</li>
          <li>Contains at least one uppercase letter</li>
          <li>Contains at least one lower case letter</li>
          <li>Contains at least one special character</li>
          <li>Is at least 12 characters long</li>
        </ul>
      </div>
    </div>
    <div [formGroup]="passwords" class="form-group" [ngClass]="{'danger': passwords.invalid && submitted}">
      <label for="passwordAgain">Confirm password</label>
      <span *ngIf="passwords.hasError('passwordsMatch') && submitted" class="validation-msg">Passwords don't match</span>
      <input id="passwordAgain" #field2 [ngClass]="{'check':passwords.controls['password'].valid && passwords.valid}" class="form-control" type="password" [formControl]="passwords.controls['passwordAgain']">
    </div>
    <div class="btn-group center margin">
      <button class="std-btn focus-element" type="submit" [disabled]="submitting">
        <span class="focus--content" tabindex="-1">
          {{ submitting === true ? "Requesting..." : "Submit"}}
        </span>
      </button>
    </div>
  </form>
</div>
